"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBasketaddonsRequestToJSON = exports.DeleteBasketaddonsRequestFromJSONTyped = exports.DeleteBasketaddonsRequestFromJSON = exports.instanceOfDeleteBasketaddonsRequest = void 0;
/**
 * Check if a given object implements the DeleteBasketaddonsRequest interface.
 */
function instanceOfDeleteBasketaddonsRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "basketId" in value;
    isInstance = isInstance && "basketItemId" in value;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
exports.instanceOfDeleteBasketaddonsRequest = instanceOfDeleteBasketaddonsRequest;
function DeleteBasketaddonsRequestFromJSON(json) {
    return DeleteBasketaddonsRequestFromJSONTyped(json, false);
}
exports.DeleteBasketaddonsRequestFromJSON = DeleteBasketaddonsRequestFromJSON;
function DeleteBasketaddonsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'basketId': json['basketId'],
        'basketItemId': json['basketItemId'],
        'token': json['token'],
    };
}
exports.DeleteBasketaddonsRequestFromJSONTyped = DeleteBasketaddonsRequestFromJSONTyped;
function DeleteBasketaddonsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'basketId': value.basketId,
        'basketItemId': value.basketItemId,
        'token': value.token,
    };
}
exports.DeleteBasketaddonsRequestToJSON = DeleteBasketaddonsRequestToJSON;
